import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Discount, DiscountWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateDiscount(): UseMutationResult<
  AxiosResponse<Discount>,
  AxiosError<ErrorMessage>,
  DiscountWrite
> {
  const queryClient = useQueryClient();

  const createDiscount = useCallback((discount: DiscountWrite): Promise<AxiosResponse<Discount>> => {
    return client.post('discounts/', discount);
  }, []);

  return useMutation(createDiscount, {
    onSuccess: () => {
      queryClient.invalidateQueries('discounts');
    },
  });
}
